export const SEND_BRIEF_ALL = 'Dyzio/SendBriefAll/SEND_BRIEF_ALL';



/** WEBPACK FOOTER **
 ** ./src/containers/send-brief-all-modal/constants.js
 **/